import { render } from "./AssociateFinancialLifeView.vue?vue&type=template&id=69fe7568&scoped=true"
import script from "./AssociateFinancialLifeView.vue?vue&type=script&lang=js"
export * from "./AssociateFinancialLifeView.vue?vue&type=script&lang=js"

import "./AssociateFinancialLifeView.vue?vue&type=style&index=0&id=69fe7568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fe7568"]])

export default __exports__